// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3Ab5o","insightsList":"newBusinessInsightsMenu_insightsList__1QZ1W","active":"newBusinessInsightsMenu_active__RTT2w"};